import * as React from 'react';
import { UilImage } from '@iconscout/react-unicons';
import MediaManager from '../../../libraries/mediaLibrary/MediaManager';
import { MULTIMEDIA_TYPES } from '@nexxt/common/types';

interface ImageButtonProps {
    addNewBubble: (type, data) => void;
}
const ImageButton: React.FC<ImageButtonProps> = ({
    addNewBubble
}: ImageButtonProps) => {
    const [showMediaManager, setShowMediaManager] = React.useState(false);
    const handleMediaSelect = (data) => {
        switch (data.type) {
            case 'audio':
                addNewBubble(MULTIMEDIA_TYPES.AUDIO, { ...data });
                break;
            case 'video':
                addNewBubble(MULTIMEDIA_TYPES.VIDEO, { ...data });
                break;
            default:
                addNewBubble(MULTIMEDIA_TYPES.IMAGE, { ...data });
        }
    };
    return (
        <div className="dynamic--reference--container">
            <MediaManager
                showMediaManager={showMediaManager}
                toggleMediaManager={setShowMediaManager}
                showMediaLibrary
                applyCurrentMedia={handleMediaSelect}
            >
                <div
                    className="rdw-option-wrapper"
                    onClick={() => setShowMediaManager(true)}
                >
                    <UilImage size={20} />
                </div>
            </MediaManager>
        </div>
    );
};

export default ImageButton;
